import { render, staticRenderFns } from "./page_detail.vue?vue&type=template&id=5686500b&"
import script from "./page_detail.vue?vue&type=script&lang=js&"
export * from "./page_detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports